import { BasicDownload } from '../../icons/basic';
import { TextLink } from '../buttons/TextLink';
import { Typography } from '../typography/Typography';

type DownloadProps = {
  description?: string;
  document: React.ReactElement;
  testid?: string;
};

export const Download = ({
  description,
  document,
  testid,
}: DownloadProps) => {
  return (
    <div
      className="space-y-2 border-b border-download py-4"
      data-testid={testid}
    >
      <TextLink
        iconRight={BasicDownload}
        size="small"
        disableIconAnimation={true}
        fullWidth={true}
      >
        {document}
      </TextLink>
      {description && (
        <Typography
          variant="content-body"
          textColorClassname="text-download-text"
        >
          {description}
        </Typography>
      )}
    </div>
  );
};
